import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.wore_user_assigned_uid !== model.wore_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.wore_user_modified_uid,
						assignedTo: modifiedModel.wore_user_assigned_uid,
						title: 'Nuovo Rapportino assegnato',
						body: `${model.user_modified_title} ti ha assegnato a "${model.wore_title}".`,
						url: `${window.location.origin}/workreports/details/${model.wore_uid}`,
						icon: 'text-box-multiple-outline',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
